module.exports = __webpack_public_path__ + "static/media/muscle_back_14.8771ed8c.png";